<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
		<g fill="none" fill-rule="nonzero">
			<circle cx="18" cy="18" r="18" :fill="globalColors.primary"/>
			<path fill="#FFF" d="M9.702 19.328v-8.475c0-.471.383-.853.856-.853h8.505c.473 0 .856.382.856.853v8.475a.285.285 0 0 1-.285.284H9.987a.285.285 0 0 1-.285-.284zm6.868 2.903c0 .977-.795 1.769-1.776 1.769-.98 0-1.776-.792-1.776-1.769 0-.976.795-1.768 1.776-1.768.98 0 1.776.792 1.776 1.768zm-.888 0a.886.886 0 0 0-.888-.884.886.886 0 0 0-.888.884c0 .489.398.885.888.885s.888-.396.888-.885zm-2.417-1.768h-3.98a.285.285 0 0 0-.285.284v.862c0 .157.128.285.285.285h3.19a2.33 2.33 0 0 1 .79-1.431zM25.86 22.23c0 .977-.795 1.769-1.776 1.769-.98 0-1.776-.792-1.776-1.769 0-.976.795-1.768 1.776-1.768.98 0 1.776.792 1.776 1.768zm-.888 0a.886.886 0 0 0-.888-.884.886.886 0 0 0-.888.884c0 .489.398.885.888.885s.888-.396.888-.885zM29 20.747v.862a.285.285 0 0 1-.285.285h-2.311a2.345 2.345 0 0 0-4.638 0h-4.653a2.33 2.33 0 0 0-.79-1.431h4.412v-8.13a.57.57 0 0 1 .57-.57H24c.759 0 1.468.376 1.892 1.002l1.737 2.563c.255.375.391.819.391 1.272v3.863h.695c.157 0 .285.127.285.284zm-2.895-5.354l-1.39-1.966a.286.286 0 0 0-.232-.12h-2.167a.285.285 0 0 0-.285.284v1.966c0 .157.127.284.285.284h3.556c.23 0 .366-.26.233-.448z"/>
		</g>
	</svg>

</template>
<script>
export default {
	name: 'pay-svg',
};
</script>



// WEBPACK FOOTER //
// truck.vue?6b1f156c